import React from "react";
import "./Categories.scss";
import { Link } from "react-router-dom";

const Categories = () => {
  return (
    <div className="categories">
      <div className="bigBoxOne">
        <Link to="/Shop" className="img_con">
          <img src={require("../../img/hero_img/c2.jpg")} alt="Product 6" />
        </Link>
      </div>

      <div className="bigBoxTwo">
        <Link to="/Shop" className="img_con">
          <img src={require("../../img/hero_img/c1.jpg")} alt="Product 3" />
        </Link>
        <Link to="/Shop" className="img_con">
          <img src={require("../../img/hero_img/c3.jpg")} alt="Product 1" />
        </Link>
        <Link to="/Shop" className="img_con">
          <img src={require("../../img/hero_img/c4.jpg")} alt="Product 7" />
        </Link>
        <Link to="/Shop" className="img_con">
          <img src={require("../../img/hero_img/c5.jpg")} alt="Product 5" />
        </Link>
      </div>
    </div>
  );
};

export default Categories;
